import { useState } from "react";
import { Link } from "react-router-dom";
import InputField from "components/fields/InputField";
import { publicPost } from "lib/apiClient";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError(null);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) return setError("Enter a valid email address.");
    setBusy(true);
    try {
      await publicPost("/portal/auth/password-reset/request", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(err.message || "Could not send the reset link. Try again shortly.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex w-full">
      <div className="w-full">
        <h4 className="mb-1.5 text-2xl font-semibold tracking-tight text-foreground">Reset your password</h4>
        {sent ? (
          <p className="mb-6 text-sm text-muted-foreground">
            If {email.trim()} belongs to a partner account, a reset link is on its way. It works once and expires within the hour.
          </p>
        ) : (
          <>
            <p className="mb-6 text-sm text-muted-foreground">Enter the email you sign in with and we will send you a reset link.</p>
            <form onSubmit={submit} noValidate>
              <InputField variant="auth" extra="mb-3" label="Email" placeholder="you@yourcompany.com" id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
              {error && <p className="mb-3 text-sm font-medium text-red-500">{error}</p>}
              <button
                type="submit"
                disabled={busy}
                className="mt-1 inline-flex h-10 w-full items-center justify-center rounded-sm bg-primary px-6 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:opacity-60"
              >
                {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
          </>
        )}
        <Link to="/auth/sign-in" className="mt-6 inline-block text-sm font-medium text-link hover:underline">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
